import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"
import {teacherLounge} from "../apiConfigs"

export const TeacherLoungeApi = createAsyncThunk(
    'auth/analytics/TeacherLoungeApi',
    async (requestData, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(teacherLounge, { params: requestData })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const TeacherLoungeSlice = createSlice({
    name: 'analytics/TeacherLoungeApi',
    initialState: { result: [], loading: false, error: null, message: "", total: 0 },
    extraReducers: (builder) => {
        builder.addCase(TeacherLoungeApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(TeacherLoungeApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.results
            state.message = action?.payload?.message
            state.total = action?.payload?.count
        })
        builder.addCase(TeacherLoungeApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const TeacherLoungeReducer = TeacherLoungeSlice.reducer